import { useEffect, useRef } from 'react';

import { abonnerSession, lireSession } from '../auth/session';

/**
 * Labo matériel : le vrai firmware de la carte, compilé pour le serveur, avec un faux modem et
 * une carte OpenStreetMap (labo/ à la racine du dépôt, service genviz-labo).
 *
 * La page du labo est servie par nginx sous /labo-sim/, sur la même origine que le back-office. Elle
 * n'a pas de compte à elle : on lui passe le jeton d'accès de l'opérateur par postMessage, et le
 * serveur du labo le fait vérifier par l'API interne avant d'ouvrir la WebSocket. Le jeton est
 * renvoyé à chaque rafraîchissement de session.
 */
export function LaboPage(): JSX.Element {
  const cadre = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const transmettre = (): void => {
      const jeton = lireSession().jetonAcces;
      const fenetre = cadre.current?.contentWindow;
      if (jeton && fenetre) fenetre.postMessage({ type: 'genviz-labo-jeton', jeton }, window.location.origin);
    };
    // La page du labo réclame le jeton quand elle est prête (elle peut se recharger seule).
    const surMessage = (e: MessageEvent): void => {
      if (e.origin === window.location.origin && e.data?.type === 'genviz-labo-pret') transmettre();
    };
    window.addEventListener('message', surMessage);
    const desabonner = abonnerSession(transmettre);
    return () => {
      window.removeEventListener('message', surMessage);
      desabonner();
    };
  }, []);

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <h1 style={{ margin: 0 }}>Labo matériel</h1>
      <p style={{ margin: 0, color: 'var(--gv-texte-2)' }}>
        Cartes simulées : le vrai firmware tourne sur le serveur, avec un faux modem, et parle au vrai
        broker. Leurs numéros de série (IMEI 99000001…) ne sont pas du matériel.
      </p>
      <iframe
        ref={cadre}
        onLoad={() => {
          const jeton = lireSession().jetonAcces;
          if (jeton) cadre.current?.contentWindow?.postMessage({ type: 'genviz-labo-jeton', jeton }, window.location.origin);
        }}
        src="/labo-sim/"
        title="Labo matériel"
        style={{ width: '100%', height: 'calc(100vh - 210px)', minHeight: 560, border: '1px solid #d9ddd3', borderRadius: 8 }}
      />
    </div>
  );
}
